export default "__VITE_ASSET__DMtCdGjU__"